import { render, staticRenderFns } from "./founders.vue?vue&type=template&id=3ed1d4c0&scoped=true&"
import script from "./founders.vue?vue&type=script&lang=js&"
export * from "./founders.vue?vue&type=script&lang=js&"
import style0 from "./founders.vue?vue&type=style&index=0&id=3ed1d4c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1d4c0",
  null
  
)

export default component.exports